<ng-container *ngIf="environmentType === environmentTypes.prod">
  <ng-container *ngIf="metricCodes$ | async as metricCodes">
    <app-ya-metric *ngIf="metricCodes.yam" [codes]="metricCodes.yam"></app-ya-metric>
    <app-ga-metric *ngIf="metricCodes.ga" [codes]="metricCodes.ga"></app-ga-metric>
    <app-gtag-metric *ngIf="metricCodes.gtag" [codes]="metricCodes.gtag"></app-gtag-metric>
  </ng-container>
</ng-container>
